var scForms = {};
(function () {
    var hideElemenCssClass = 'd-none';
    var showElementCssClass = 'd-block';
    var displayGdprTextAttrName = 'data-gdpr-display-text';
    var selectedOption = 'option:selected';
    var isGdprCountryAttrname = 'data-is-gdpr-country';
    var sideTextAttrname = 'data-side-text-id';
    var bindingCtrlAttrName = 'data-sc-field-name';
    var bindingCtrlAttrIdName = 'binding-control-id';
    var bindingFieldValidationAttrName = 'binding-field-validation';
    var lblErrorMsgAttrName = 'data-valmsg-for';
    var sideTextOptionAttr = 'side-text';

    $(document).ready(function () {
        init();
    });
    this.enableGdpr = function (control) {
        var element = $(control).find(selectedOption);
        var isGdprCoutry = element.attr(isGdprCountryAttrname);
        var sideTextClassName = $(control).attr(sideTextAttrname);
        var bindingCtrlAttrIdNameValue = $(control).attr(bindingCtrlAttrIdName);
        if (bindingCtrlAttrIdNameValue !== null && typeof bindingCtrlAttrIdNameValue !== "undefined" && bindingCtrlAttrIdNameValue !== "") {
            var bindingcontrolSelector = '[' + bindingCtrlAttrName + '=' + $(control).attr(bindingCtrlAttrIdName) + ']';
            $(bindingcontrolSelector).removeClass(hideElemenCssClass);
            $(bindingcontrolSelector).addClass(showElementCssClass);
            $(bindingcontrolSelector).next($(".icon")).removeClass(hideElemenCssClass);
            $(bindingcontrolSelector).next($(".icon")).addClass(showElementCssClass);
            var bindingControl = $('[' + bindingCtrlAttrName + '=' + $(control).attr(bindingCtrlAttrIdName) + ']:visible');

            var controlId = '#' + $(bindingControl).attr("id") + "_msg";
            $(controlId).html('');
            $(bindingControl).removeClass(showElementCssClass);
            $(bindingControl).addClass(hideElemenCssClass);
            $(bindingControl).next($(".icon")).removeClass(showElementCssClass);
            $(bindingControl).next($(".icon")).addClass(hideElemenCssClass);
            if (sideTextClassName != null && sideTextClassName != '') {
                var sideTextControl = $('.' + sideTextClassName);
                if (sideTextControl != null && typeof sideTextControl !== "undefined") {
                    var sideText = element.attr(sideTextOptionAttr);
                    sideTextControl.html(sideText);
                }
            }
            if (isGdprCoutry != null && typeof isGdprCoutry !== "undefined" && isGdprCoutry == "True") {
                $(bindingControl).removeClass(hideElemenCssClass);
                $(bindingControl).addClass(showElementCssClass);
                $(bindingControl).next($(".icon")).removeClass(hideElemenCssClass);
                $(bindingControl).next($(".icon")).addClass(showElementCssClass);
                var text = element.attr(displayGdprTextAttrName);
                $(controlId).html(text);
                var isControlToValidate = $(control).attr(bindingFieldValidationAttrName);

                $(bindingControl).rules('remove', 'required');
                if (isControlToValidate === "True") {
                    $(bindingControl).rules('add', 'required');
                }
            } else {
                var errorMsgLabel = $('[' + lblErrorMsgAttrName + '="' + $(bindingControl).attr('name') + '"]');
                if (errorMsgLabel != null) {
                    errorMsgLabel.html('');
                }
            }
        }
    };
    this.bindChildDropdown = function (control) {
        var bindChildDropdown = $(control).attr('bind-child-dropdown');

        if (bindChildDropdown && bindChildDropdown == 'True') {
            var element = $(control).find(selectedOption);
            var bindControlName = $(control).attr("child-dropdown-id");
            var childControl = $('[' + bindingCtrlAttrName + '=' + bindControlName + ']');
            var showEmptyItem = $(childControl).attr('show-empty-item');
            if (element) {
                childControl.empty();
                if (showEmptyItem && showEmptyItem === "True") {
                    var dispText = $(childControl).attr("display-text-for-empty-item");
                    childControl.append($("<option></option>").val('').html(dispText));
                }

                var childDropdownData = $.parseJSON(element.attr('child-dropdown-data'));
                if (childDropdownData) {
                    $.each(childDropdownData,
                        function (index, data) {
                            childControl.append($("<option></option>").val(data.Value).html(data.Key));
                        });
                } else {
                    childControl.empty();
                }
            }
        }
    }
    this.clearSelection = function (scDataFieldName) {
        if (scDataFieldName !== null && typeof scDataFieldName !== "undefined" && scDataFieldName !== '') {
            $("[data-sc-field-name = '" + scDataFieldName + "']").removeAttr('checked');
        }
    }
    function init() {
        // scForms.enableGdpr();
        //Avoid multiple triggers of form close event
        $(".c04-lightbox button, .modal-dialog .form-cancel").off("click.form.close").on("click.form.close", function () {
            resetActiveForm($(this).closest("[lightboxmodalcontainer]:has(form)").find("form"));
        });
        function resetActiveForm(activeForm) {
            if (activeForm.length) {
                resetForm();
                $(activeForm).find(".hdn-form-btn-close").click();
            }
        }
        function resetForm() {
            var forms = $('.xom-form');
            for (var i = 0; i < forms.length; i++) {
                var formId = '#' + $(forms[i]).attr('id');
                if (formId) {
                    var form = $(formId);
                    setTimeout(function () {
                        var firstVisbleFormInput = $(formId).find('input[type="text"]:visible:first');
                        if (firstVisbleFormInput.length > 0) {
                            $(firstVisbleFormInput[0]).focus();
                        }
                    },
                        500);
                    if (form) {
                        var validator = form.validate();
                        if (validator) {
                            validator.resetForm();
                        }
                        $(formId + " .field-validation-error").addClass("field-validation-valid");
                        $(formId + " .field-validation-valid").removeClass("field-validation-error");
                        $(formId + " .field-validation-valid").text('');
                    }
                }
            }
        }
        //Avoid multiple triggers of form close event
        $('body').off('click.form.close').on('click.form.close', '.form-btn-close', function () {
            resetActiveForm($(this).closest("form"));
        });

        $("[lightboxmodalcontainer]").on("shown.bs.modal", function () {
            scForms.enableGdpr($(this).find("select"));
        });

        $('.pds-share-link').on('click', function () {
            resetForm();
            $(".hdn-form-btn-close").click();
        });
        //Change is related to handle library-detail page share form since the url is formed differently for form action.
        if ($("form").length > 0) {
            $("form").each(function (index) {
                if ($(this).attr("action") != undefined) {
                    var actionURI = $(this).attr("action").split('/');
                    if (actionURI.length > 2) {
                        $(this).attr("action", ('/' + actionURI[actionURI.length - 1]))
                    }
                }
            });
        }
    }

    this.enableMultiLineTextCounter = function (scDataFieldName) {
        var counter = scDataFieldName.value.length;
        $("#charactercount").text(counter);
    };
}).apply(scForms);